var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "favorites-section__topic" }, [
      _c("div", { staticClass: "favorites-section__topic-quantity" }, [
        _vm._v(
          _vm._s(_vm.properties.length || 0) +
            " " +
            _vm._s(
              _vm.locales && _vm.locales.common && _vm.locales.common.properties
            )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "theme-order-select ml-auto pl-2.5" }, [
        _c(
          "select",
          {
            staticClass: "theme-order-select__item",
            attrs: { name: "order" },
            on: { change: _vm.sort }
          },
          [
            _c(
              "option",
              {
                attrs: { value: "published_at_desc" },
                domProps: { selected: _vm.order === "published_at_desc" }
              },
              [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.most_recent
                    ) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "option",
              {
                attrs: { value: "published_at_asc" },
                domProps: { selected: _vm.order === "published_at_asc" }
              },
              [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.oldest_first
                    ) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "option",
              {
                attrs: { value: "location_asc" },
                domProps: { selected: _vm.order === "location_asc" }
              },
              [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.location_a_z
                    ) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "option",
              {
                attrs: { value: "location_desc" },
                domProps: { selected: _vm.order === "location_desc" }
              },
              [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.location_z_a
                    ) +
                    "\n            "
                )
              ]
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "favorites-section__list" },
      _vm._l(_vm.properties, function(property) {
        return _c(
          "div",
          {
            staticClass:
              "favorites-section__list-item grid-cols-12 items-center gap-2 lg:grid"
          },
          [
            _c("div", { staticClass: "col-span-1 mb-3 lg:mb-0" }, [
              _c("img", {
                staticClass: "favorites-section__list-item-image",
                attrs: { src: property.listingMainPhoto, alt: "image" }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-span-5 grid grid-cols-12 items-center lg:pr-5 mb-3 lg:mb-0"
              },
              [
                _c("div", { staticClass: "col-span-9 pr-5" }, [
                  _c(
                    "h4",
                    { staticClass: "favorites-section__list-item-name" },
                    [_vm._v(_vm._s(property.listingAddress))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "favorites-section__list-item-note" },
                    [_vm._v(_vm._s(property.fullAddress))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-span-3 text-right lg:text-left" },
                  [
                    this.location.href.indexOf("staffhousing") == -1 &&
                    property.show_price == 1
                      ? [
                          _c("div", { staticClass: "mb-2" }, [
                            _vm._v(
                              "€ " +
                                _vm._s(
                                  property.ah_price &&
                                    property.ah_price.indexOf(",00") == -1
                                    ? property.ah_price.indexOf(",") != -1
                                      ? property.ah_price
                                      : property.ah_price + ",-"
                                    : property.ah_price
                                    ? property.ah_price.replace(",00", ",-")
                                    : ""
                                ) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "favorites-section__list-item-note"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.locales.properties &&
                                      _vm.locales.properties.a_month
                                  ) +
                                  "\n              "
                              ),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    property.ah_price_includes_short
                                  )
                                }
                              })
                            ]
                          )
                        ]
                      : this.location.href.indexOf("staffhousing") == -1
                      ? [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.locales.properties &&
                                  _vm.locales.properties.price_on_request
                              ) +
                              "\n          "
                          )
                        ]
                      : [
                          _vm._v(
                            "\n            " +
                              _vm._s(property.max_people) +
                              " " +
                              _vm._s(
                                _vm.locales.properties &&
                                  _vm.locales.properties.max_number_of_persons
                              ) +
                              "\n          "
                          )
                        ]
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-span-2 grid grid-cols-2 lg:grid-cols-1 mb-3 lg:mb-0 lg:pr-5"
              },
              [
                _c("div", { staticClass: "lg:hidden" }, [
                  _vm._v("Property type:")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-right lg:text-left" }, [
                  _c("div", { staticClass: "mb-2" }, [
                    _vm._v(_vm._s(property.type && property.type.value))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "favorites-section__list-item-note" },
                    [
                      _vm._v(
                        _vm._s(property.no_bedrooms) +
                          "\n            " +
                          _vm._s(
                            _vm.locales.properties &&
                              _vm.locales.properties.bedrooms
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-span-2 grid grid-cols-2 lg:grid-cols-1 mb-3 lg:mb-0 lg:pr-5"
              },
              [
                _c("div", { staticClass: "lg:mb-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm.locales.properties &&
                        _vm.locales.properties.available_on
                    ) + ":"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-right lg:text-left" }, [
                  _vm.isUnavailable(property.status)
                    ? _c(
                        "div",
                        { staticClass: "favorites-section__list-item-note" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                property.status && property.status.attribute
                                  ? property.status.attribute.slug
                                  : "Unavailable"
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "favorites-section__list-item-note" },
                        [_vm._v(_vm._s(property.available_on))]
                      )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-span-2 flex items-center" }, [
              !_vm.isUnavailable(property.status)
                ? _c(
                    "a",
                    {
                      staticClass:
                        "theme-btn theme-btn--small theme-btn--theme theme-btn--block lg:mr-5",
                      attrs: { href: property.url }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.locales &&
                              _vm.locales.common &&
                              _vm.locales.common.view_details
                          ) +
                          "\n          "
                      ),
                      _c("span", { staticClass: "icon-thin-right text-[20px]" })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isUnavailable(property.status)
                ? _c("div", {
                    staticClass: "favorites-section__list-item-unavailable"
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "favorites-section__list-item-heart",
                  on: {
                    click: function($event) {
                      return _vm.remove(property.id)
                    }
                  }
                },
                [_c("div", { staticClass: "icon-heart-filled text-[20px]" })]
              )
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c90c7d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c90c7d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/FavoritesListing.vue
// module id = 753
// module chunks = 1